import type { AnalysisCapabilities, AnalysisCommand, AnalysisReply } from '@playcastdotio/Messaging';

export type AnalysisHostActivity = 'idle' | 'calibration' | 'preview';
export interface AnalysisHostSurface { running: AnalysisHostActivity; queuedPreview: boolean }
export interface INativeMacroAnalysisClient {
  capabilities(): Promise<AnalysisCapabilities>;
  send(command: AnalysisCommand): Promise<void>;
  subscribe(listener: (reply: AnalysisReply) => void): () => void;
  noteAssignment(running: AnalysisHostActivity, queuedPreview: boolean): void;
  surface(): AnalysisHostSurface;
}
export interface AnalysisClientLogger { event(name: string, fields: Record<string, string | number | boolean>): void }

/** Browser/mock environments cannot advertise or impersonate a hardware GPU worker. */
export class UnavailableNativeMacroAnalysisClient implements INativeMacroAnalysisClient {
  public async capabilities(): Promise<AnalysisCapabilities> { throw new Error('analysis_native_unavailable'); }
  public async send(_command: AnalysisCommand): Promise<void> { throw new Error('analysis_native_unavailable'); }
  public subscribe(_listener: (reply: AnalysisReply) => void): () => void { return () => {}; }
  public noteAssignment(_running: AnalysisHostActivity, _queuedPreview: boolean): void {}
  public surface(): AnalysisHostSurface { return { running: 'idle', queuedPreview: false }; }
}
